import xiaoMessage from 'utils/xiao-message/main.js'

export default function install(Vue) {
  Vue.prototype.$xiaoMessage = xiaoMessage
}